// Indicates a permission needed to access a page at all
export const ACCESS_ROUTE = "accessPage";

export enum OrganizationActions {
	ADMIN_ORG = "adminOrg",
	// READ_ORG = "readOrg",
}

export enum WorkspacesActions {
	ADMIN_WORKSPACE = "adminWorkspace",
	READ_WORKSPACE = "readWorkspace",
	UPDATE_WORKSPACE = "updateWorkspace",
	CREATE_FOLDER = "createFolder",
	CREATE_FLOW = "createFlow",
	UPDATE_FLOW = "updateFlow",
	DELETE_FLOW = "deleteFlow",
	READ_CONTACT = "readContact",
	CREATE_BRAND_KIT = "createBrandKit",
	UPDATE_BRAND_KIT = "updateBrandKit",
	DELETE_BRAND_KIT = "deleteBrandKit",
	CREATE_STATIC_ASSET = "createStaticAsset",
	READ_STATIC_ASSET = "readStaticAsset",
	UPDATE_STATIC_ASSET = "updateStaticAsset",
	DELETE_STATIC_ASSET = "deleteStaticAsset",
}

export enum ConversionEditorActions {
	// READ_FLOW = "viewFlow",
	UPDATE_FLOW = "updateFlow",
	// DELETE_FLOW = "deleteFlow",
}

export enum BuilderActions {
	PUBLISH_ORG = "publishOrg",
	PUBLISH_GLOBAL = "publishGlobal",
}

export enum BrandKitActions {
	UPDATE = "updateBrandKit",
}
